/**
 * Generated runtime TestId mirror for frontend/src/components/account/AccountStatusHeader.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const AccountStatusHeaderTestIds = {
  accountStatusHeaderActor: "account-status-header-actor",
  accountStatusHeaderFromStatus: "account-status-header-from-status",
  accountStatusHeaderReason: "account-status-header-reason",
  accountStatusHeaderSummary: "account-status-header-summary",
  accountStatusHeaderTimestamp: "account-status-header-timestamp",
  accountStatusHeaderToStatus: "account-status-header-to-status",
  accountStatusHeaderTriggerSource: "account-status-header-trigger-source",
  accountStatusHeaderViewTimeline: "account-status-header-view-timeline",
  skeleton: (root: string) => `${root}-skeleton`,
  unavailable: (root: string) => `${root}-unavailable`
} as const;
